(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gp-solar-editorial"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gp-solar-selection')) {
  customElements.define('gp-solar-selection', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.closest('[id^="shopify-section-"]')?.addEventListener('click', event => {
        const option = event.target.closest('hdt-variant-picker [role="option"]');
        if (!option) return;
        const link = Array.from(this.querySelectorAll('[data-variant-id]')).find(item => item.title === option.getAttribute('value'));
        if (!link) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        window.location.assign(link.href);
      }, {signal: this.controller.signal, capture: true});
      this.closest('[id^="shopify-section-"]')?.addEventListener('variant:change', event => {
        const id = event.detail?.variant?.id;
        this.querySelectorAll('[data-variant-id]').forEach(link => {
          if (id && link.dataset.variantId === String(id)) link.setAttribute('aria-current', 'true');
          else link.removeAttribute('aria-current');
        });
      }, {signal: this.controller.signal, capture: true});
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
  } catch(e) { console.error(e); }
})();

})();
